import Model from "../candidates-reservation-model"
import FormErrors from "@/util/form-errors"
import CandidateRequestsValidator from '../models/validation/CandidateRequestsValidator'
import { mapActions } from 'vuex'

export default {
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    activeItems: {
      type: Array,
      default: () => []
    }
  },
  inject: ['svc'],
  data: () => ({
    model: new Model(),
    formErrors: new FormErrors(),
    showing: false,
    loading: false,
  }),
  methods: {
    ...mapActions({
      getExamLocation: 'crmExamLocation/list',
      getCourseLocation: 'crmCourseCities/list'
    }),
    toggle() {
      this.showing = !this.showing
    },
    submit() {
      this.model.requests = this.$refs.reservations.requests
      this.formErrors.resetFields()
      let exchangeRequests = this.model._getRemoveRequestsApiDataBy(this.$refs.reservations.requests)
      new CandidateRequestsValidator(this.model.requests, this.formErrors, 'requests').validate()
      if (exchangeRequests.length) {
        let fieldsNotFilled = Object.values(exchangeRequests[0]).every(field => !field)
        if(fieldsNotFilled) {
          this.$notify({text: 'Please, fill fields before sent', type: 'error'})
          return
        }
      }
      if(!this.formErrors.isValid()) {
        this.$notify({text: 'Invalid fields', type: 'error'})
        return
      }
      this.send()
    },
  },
  components: {
    reservations: () => import('../../components/item/CanditeReservations.vue'),
  }
}